export default __webpack_public_path__ + "static/media/contact-bg.a55a00a8.png";